import { Component, Inject } from '@angular/core';
import { LinkService } from '../../services/link.service';
import { APP_CONFIG, AppConfig } from '../../../appconfig/appconfig';

@Component({
  selector: 'app-welcome-card',
  templateUrl: './welcome-card.component.html',
  styleUrl: './welcome-card.component.scss',
})
export class WelcomeCardComponent {
  constructor(@Inject(APP_CONFIG) private appConfig: AppConfig) {}

  openJiraLink(): void {
    LinkService.OpenExternalLink(this.appConfig.jiraLink);
  }
}
